import { render, staticRenderFns } from "./WeeklyPrizes.vue?vue&type=template&id=f5997968&scoped=true&"
import script from "./WeeklyPrizes.vue?vue&type=script&lang=js&"
export * from "./WeeklyPrizes.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyPrizes.vue?vue&type=style&index=0&id=f5997968&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5997968",
  null
  
)

export default component.exports